import type { ReactElement } from 'react';
import { Search, Bot, HardDrive, Fingerprint, Monitor } from 'lucide-react';
import type { NetworkTrafficStats } from '@kirin/api-client/contracts/shadow-ai';
import { MetricCard } from '@/components/ui/metric-card';
import { formatBytes } from './shared';

export function NetworkTrafficDashboard({
  stats,
  isLoading,
  onUnreviewedClick,
  onIdentifiedClick,
}: {
  stats: NetworkTrafficStats | undefined;
  isLoading: boolean;
  onUnreviewedClick?: () => void;
  onIdentifiedClick?: () => void;
}): ReactElement {
  if (isLoading || !stats) {
    return (
      <div className="grid grid-cols-5 gap-5 mb-6">
        {[...Array(5)].map((_, i) => (
          <div
            key={i}
            className="rounded-lg p-5 animate-pulse bg-white dark:bg-slate-800/40 border border-slate-200 dark:border-slate-700/40"
          >
            <div className="w-9 h-9 rounded-lg bg-slate-100 dark:bg-slate-700/50" />
            <div className="h-8 w-12 rounded bg-slate-100 dark:bg-slate-700/50 mt-3" />
            <div className="h-4 w-24 rounded bg-slate-100 dark:bg-slate-700/50 mt-1" />
          </div>
        ))}
      </div>
    );
  }

  const totalTraffic = stats.totalBytesIn + stats.totalBytesOut;

  return (
    <div className="grid grid-cols-5 gap-5 mb-6">
      <MetricCard
        variant="neutral"
        icon={Search}
        label="Unreviewed"
        value={stats.pendingCount}
        onClick={onUnreviewedClick}
        muteWhenZero
      />
      <MetricCard
        variant="success"
        icon={Bot}
        label="Identified"
        value={stats.approvedCount + stats.flaggedCount}
        onClick={onIdentifiedClick}
      />
      <MetricCard
        variant="info"
        icon={HardDrive}
        label="Total Traffic"
        value={totalTraffic}
        displayValue={formatBytes(totalTraffic)}
      />
      <MetricCard
        variant="neutral"
        icon={Fingerprint}
        label="Fingerprints"
        value={stats.uniqueJa4Count}
      />
      <MetricCard
        variant="neutral"
        icon={Monitor}
        label="Endpoints"
        value={stats.uniqueMachines}
      />
    </div>
  );
}
